import Microgame from '../engine/Microgame.js';

export default class StampGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Tamponne !`, en: `Stamp!`, es: `¡Sella!` },
            controls: { fr: `Glisse le tampon sur le document et relâche`, en: `Drag the stamp to the document and release`, es: `Arrastra el sello al documento y suelta` },
            objective: { fr: `Valide le document au bon endroit`, en: `Approve the document in the right spot`, es: `Aprueba el documento en el lugar correcto` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M6 22h12M12 2v6"/><rect x="4" y="8" width="16" height="8" rx="2"/></svg>`,
            actions: [
                { type: 'wait', duration: 980 },
                { type: 'tap', x: 50, y: 52, duration: 180 },
                { type: 'wait', duration: 520 },
            ],
            loopDuration: 2600
        };
    }
    constructor(engine) {
        super(engine);
        this.paper = null;
        this.stamp = null;
        this.paperX = -50; // Start off screen left
        this.speed = 300; // px/s
        this.stamped = false;

        // Difficulty scaling
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeedScale = 1 + (speedMult - 1) * 0.7;
        this.duration = 1750 * (speedMult / adjustedSpeedScale);
    }

    setup() {
        this.engine.ui.instruction.textContent = "STAMP!";

        // Dynamic speed based on time to ensure it reaches center around 55% of max time
        const speedMult = this.engine.speedMultiplier || 1.0;
        const actualTimeSeconds = (this.duration / speedMult) / 1000;
        const containerRect = this.container.getBoundingClientRect();
        const width = containerRect.width > 0 ? containerRect.width : window.innerWidth;
        const distanceToCenter = (width / 2) + 50; 
        this.speed = distanceToCenter / (actualTimeSeconds * 0.55);

        // Target Zone (Outline)
        const target = document.createElement('div');
        target.style.position = 'absolute';
        target.style.width = '120px';
        target.style.height = '160px';
        target.style.border = `4px dashed ${this.secondaryColor}`;
        target.style.top = '50%';
        target.style.left = '50%';
        target.style.transform = 'translate(-50%, -50%)';
        target.style.opacity = '0.3';
        this.container.appendChild(target);

        // Paper (Secondary)
        this.paper = document.createElement('div');
        this.paper.style.position = 'absolute';
        this.paper.style.width = '120px';
        this.paper.style.height = '160px';
        this.paper.style.background = '#fff';
        this.paper.style.top = '50%';
        this.paper.style.left = '0px';
        this.paper.style.transform = 'translate(-50%, -50%)';
        this.paper.style.boxShadow = `0 0 10px #fff`;
        this.container.appendChild(this.paper);

        // Stamp Tool (Primary) - Hovering
        this.stamp = document.createElement('div');
        this.stamp.style.position = 'absolute';
        this.stamp.style.width = '100px';
        this.stamp.style.height = '140px';
        this.stamp.style.background = this.primaryColor;
        this.stamp.style.top = '20%';
        this.stamp.style.left = '50%';
        this.stamp.style.transform = 'translate(-50%, 0)';
        this.stamp.style.borderRadius = '10px';
        this.stamp.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.stamp.style.transition = 'top 0.1s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
        this.container.appendChild(this.stamp);

        // Handle
        const handle = document.createElement('div');
        handle.style.position = 'absolute';
        handle.style.width = '40px';
        handle.style.height = '40px';
        handle.style.background = this.secondaryColor;
        handle.style.top = '-20px';
        handle.style.left = '30px';
        handle.style.borderRadius = '50%';
        this.stamp.appendChild(handle);

        this.onTap = this.onTap.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onTap);
    }

    update(dt) {
        if (this.won || this.stamped) return;

        this.paperX += this.speed * (dt / 1000);

        // Loop paper? Or just one pass? One pass is better for timing challenge.
        // If it goes off screen, fail?
        const rect = this.container.getBoundingClientRect();
        if (this.paperX > rect.width + 100) {
            this.paperX = -50; // Loop for now, or fail? Let's loop to be nice.
        }

        this.paper.style.left = `${this.paperX}px`;
    }

    onTap() {
        if (this.won || this.stamped) return;
        this.stamped = true;

        // Slam Stamp
        this.stamp.style.top = '45%'; // Overlap paper

        setTimeout(() => {
            // Check Alignment
            const rect = this.container.getBoundingClientRect();
            const paperCenter = this.paperX;
            const targetCenter = rect.width / 2;

            if (Math.abs(paperCenter - targetCenter) < 40) {
                this.win();

                // Leave Mark
                const mark = document.createElement('div');
                mark.style.position = 'absolute';
                mark.style.width = '80px';
                mark.style.height = '80px';
                mark.style.border = `5px solid ${this.primaryColor}`;
                mark.style.borderRadius = '50%';
                mark.style.top = '50%';
                mark.style.left = '50%';
                mark.style.transform = 'translate(-50%, -50%)';
                mark.style.opacity = '0.8';
                this.paper.appendChild(mark);

                // Lift Stamp
                this.stamp.style.top = '20%';
            } else {
                this.lose();
                this.stamp.style.top = '20%';
            }
        }, 150);
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onTap);
    }
}
